"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialSelection = initialSelection;
exports.EntityGusPanel = EntityGusPanel;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../View/Modals/FormContext");
const EntitiesBadges_1 = require("../EntitiesBadges");
const gusEntityService_1 = require("../gusEntityService");
/**
 * GUS-4b — okno różnic „w PS" / „w rejestrze GUS" w oknie podmiotu.
 *
 * ZASADA NADRZĘDNA PACKA (D-GUS-1): GUS proponuje, człowiek przyjmuje. Nic tutaj
 * nie zapisuje nazwy ani adresu inaczej niż przez zaznaczenie pola i kliknięcie
 * „Przyjmij zaznaczone". Trasa /gus/check zapisuje wyłącznie werdykt.
 *
 * Panel pokazuje się przy `DIFF` i `DIFF_MINOR`, czyli wtedy, gdy jest co porównywać.
 * Cztery pola (nazwa, adres, REGON, KRS) — tyle, ile umie przyjąć serwer
 * (GUS_ACCEPTABLE_FIELDS w PS-nodeJS/src/entities/gusBir/GusCompare.ts).
 *
 * Kolumnę „w PS" czytamy z FORMULARZA, nie z rekordu: człowiek mógł już coś w oknie
 * poprawić i porównywanie go z nieaktualnym odczytem byłoby kłamstwem. Po przyjęciu
 * pola wpisujemy wartość z rejestru z powrotem do formularza — inaczej „Zatwierdź"
 * w modalu odesłałby na serwer starą wartość i cofnęło przyjęcie.
 */
const FIELD_LABELS = {
    name: "Nazwa",
    address: "Adres",
    regon: "REGON",
    krs: "KRS",
};
/** Wartość widoczna dla człowieka: pusty tekst pokazujemy myślnikiem, jak w makiecie. */
function shown(value) {
    const trimmed = (value ?? "").trim();
    return trimmed.length > 0 ? trimmed : "—";
}
function differs(inPs, inGus) {
    return (inPs ?? "").trim() !== (inGus ?? "").trim();
}
/**
 * Które pola są zaznaczone przy otwarciu okna.
 *
 * Zgodnie z makietą zatwierdzoną przez właściciela: TYLKO te, przy których obie strony mają
 * wartość i te wartości się rozjeżdżają. To ta sama definicja różnicy, którą ma serwer
 * (`GusCompare` w PS-nodeJS): puste pole to brak danych, a nie sprzeczność.
 *
 * Widać to wprost na rekordzie 38 z makiety: nazwa i adres zaznaczone (obie strony mają
 * wartość, inną), REGON i KRS odznaczone (PS ich nie ma). Puste pole wolno przyjąć — wystarczy
 * je zaznaczyć — ale nikt nie robi tego za człowieka.
 */
function initialSelection(psValues, snapshot) {
    if (!snapshot)
        return [];
    return gusEntityService_1.GUS_ACCEPTABLE_FIELDS.filter((field) => (snapshot[field] ?? "").trim().length > 0 &&
        (psValues[field] ?? "").trim().length > 0 &&
        differs(psValues[field], snapshot[field]));
}
function EntityGusPanel({ entityId, initialStatus, initialCheckedAt, initialSnapshot, entityValues, }) {
    const { getValues, setValue, watch } = (0, FormContext_1.useFormContext)();
    // Kolumna „w PS" ma pokazywać to, co JEST w formularzu w tej chwili — także wtedy,
    // gdy człowiek właśnie coś w nim poprawił. `getValues` nie odświeża widoku, `watch` tak.
    // Zanim formularz się wypełni, pokazujemy wartości z rekordu.
    const psValues = {
        name: watch("name") ?? entityValues?.name,
        address: watch("address") ?? entityValues?.address,
        regon: watch("regon") ?? entityValues?.regon,
        krs: watch("krs") ?? entityValues?.krs,
    };
    const [status, setStatus] = (0, react_1.useState)(initialStatus ?? null);
    const [checkedAt, setCheckedAt] = (0, react_1.useState)(initialCheckedAt ?? null);
    const [snapshot, setSnapshot] = (0, react_1.useState)(initialSnapshot ?? null);
    const [selected, setSelected] = (0, react_1.useState)(() => initialSelection(entityValues ?? {}, initialSnapshot));
    const [pending, setPending] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const [info, setInfo] = (0, react_1.useState)(null);
    function toggle(field) {
        setSelected((current) => current.includes(field) ? current.filter((item) => item !== field) : [...current, field]);
    }
    async function handleCheck() {
        setError(null);
        setInfo(null);
        setPending("check");
        try {
            const result = await (0, gusEntityService_1.checkEntityInGus)(entityId);
            setStatus(result.status);
            setCheckedAt(result.checkedAt);
            setSnapshot(result.snapshot);
            setSelected(initialSelection({
                name: getValues("name"),
                address: getValues("address"),
                regon: getValues("regon"),
                krs: getValues("krs"),
            }, result.snapshot));
            setInfo("Sprawdzono w rejestrze. Dane podmiotu zostały nietknięte.");
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Błąd sprawdzenia w GUS");
        }
        finally {
            setPending(null);
        }
    }
    async function handleAccept() {
        if (selected.length === 0)
            return;
        setError(null);
        setInfo(null);
        setPending("accept");
        try {
            const result = await (0, gusEntityService_1.acceptGusFields)(entityId, selected);
            for (const field of result.applied) {
                const fromGus = snapshot?.[field];
                if (fromGus !== undefined)
                    setValue(field, fromGus, { shouldDirty: false, shouldValidate: true });
            }
            setStatus(result.status);
            setSelected([]);
            setInfo(`Przyjęto z rejestru: ${result.applied.map((field) => FIELD_LABELS[field]).join(", ")}.`);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Błąd przyjęcia danych z GUS");
        }
        finally {
            setPending(null);
        }
    }
    const checked = (0, EntitiesBadges_1.formatGusCheckedAt)(checkedAt);
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "mb-3" },
        react_1.default.createElement(react_bootstrap_1.Card.Header, { className: "d-flex flex-wrap align-items-center gap-2" },
            react_1.default.createElement("strong", null, "Por\u00F3wnanie z rejestrem GUS"),
            react_1.default.createElement(EntitiesBadges_1.GusStatusBadge, { status: status, checkedAt: checkedAt }),
            checked && react_1.default.createElement("span", { className: "text-muted small" },
                "sprawdzono ",
                checked)),
        react_1.default.createElement(react_bootstrap_1.Card.Body, null,
            react_1.default.createElement(react_bootstrap_1.Row, { className: "text-muted text-uppercase small border-bottom pb-1" },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 }),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 }, "w PS"),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 }, "w rejestrze GUS")),
            gusEntityService_1.GUS_ACCEPTABLE_FIELDS.map((field) => {
                const inPs = psValues[field];
                const inGus = snapshot?.[field];
                const hasGusValue = (inGus ?? "").trim().length > 0;
                const isDifferent = hasGusValue && differs(inPs, inGus);
                return (react_1.default.createElement(react_bootstrap_1.Row, { key: field, className: "border-bottom py-2 align-items-start" },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", id: `gus-accept-${field}`, "aria-label": `Przyjmij z GUS: ${FIELD_LABELS[field]}`, checked: selected.includes(field), disabled: !hasGusValue || pending !== null, onChange: () => toggle(field) })),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                        react_1.default.createElement("div", { className: "text-muted text-uppercase small" }, FIELD_LABELS[field]),
                        react_1.default.createElement("div", null, shown(inPs))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 6 },
                        react_1.default.createElement("div", { className: "text-muted text-uppercase small" }, FIELD_LABELS[field]),
                        react_1.default.createElement("div", null, isDifferent ? react_1.default.createElement("mark", null, shown(inGus)) : shown(inGus)))));
            }),
            snapshot?.closedAt && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "dark", className: "mt-3 mb-0" },
                "Rejestr podaje zako\u0144czenie dzia\u0142alno\u015Bci: ",
                snapshot.closedAt,
                ". Podmiot zostaje w s\u0142owniku razem z histori\u0105 \u2014 niczego nie ukrywamy ani nie kasujemy.")),
            react_1.default.createElement("div", { className: "d-flex flex-wrap gap-2 pt-3" },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", size: "sm", onClick: handleAccept, disabled: selected.length === 0 || pending !== null }, pending === "accept" ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-1" }),
                    "Przyjmowanie...")) : ("Przyjmij zaznaczone")),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-primary", size: "sm", onClick: handleCheck, disabled: pending !== null }, pending === "check" ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-1" }),
                    "Sprawdzanie...")) : ("Sprawdź teraz w GUS"))),
            error && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", className: "mt-3 mb-0", onClose: () => setError(null), dismissible: true }, error)),
            info && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", className: "mt-3 mb-0", onClose: () => setInfo(null), dismissible: true }, info)))));
}
